import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e1508c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Navegador")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Ocultar")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Ir para o topo")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!
  const _directive_touch_pan = _resolveDirective("touch-pan")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_page_sticky, {
    class: "text-center",
    position: "top-right",
    offset: _ctx.fabPos
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: "text-center q-mb-sm shadow-5",
        style: {"border-radius":"10px 10px 0px 0px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, {
            separator: "separator",
            style: {"border-radius":"10px 10px 0px 0px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item, {
                class: "bg-blue-7 text-white",
                clickable: "clickable",
                style: {"cursor":"move !important","border-radius":"10px 10px 0px 0px"},
                dense: "dense",
                disable: _ctx.draggingFab
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, { class: "text-caption" }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disable"]),
              _createVNode(_component_q_item, {
                clickable: "clickable",
                onClick: _ctx.warnDisabled,
                dense: "dense",
                disable: _ctx.draggingFab,
                class: _normalizeClass(_ctx.$q.dark.isActive ? 'text-white' : 'text-dark')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, { class: "text-caption" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.disabled ? 'Expandir' : 'Minimizar'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { side: "side" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        class: "expand-icon",
                        id: "expand-icon",
                        flat: "flat",
                        name: "expand_more",
                        size: "xs"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick", "disable", "class"]),
              _createVNode(_component_q_item, {
                clickable: "clickable",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('hide-nav-bar'))),
                dense: "dense",
                disable: _ctx.draggingFab,
                class: _normalizeClass(_ctx.$q.dark.isActive ? 'text-white' : 'text-dark')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item, { dense: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            size: "xs",
                            name: "visibility_off"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disable", "class"]),
              _createVNode(_component_q_item, {
                clickable: "clickable",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollTo(0))),
                disable: _ctx.draggingFab
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, { class: "text-caption" }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { side: "side" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "arrow_upward",
                        size: "xs"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disable"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_separator),
          _createVNode(_component_q_list, {
            class: "list-questions",
            id: "list-questions",
            separator: "separator"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, index) => {
                return (_openBlock(), _createBlock(_component_q_item, {
                  clickable: "clickable",
                  disable: _ctx.draggingFab,
                  class: _normalizeClass(_ctx.isHistory ? _ctx.setItemBg(question) : _ctx.classObject(question)),
                  onClick: ($event: any) => (_ctx.scrollTo(index)),
                  key: index
                }, {
                  default: _withCtx(() => [
                    (_ctx.isHistory)
                      ? (_openBlock(), _createBlock(_component_q_item_section, {
                          key: 0,
                          side: "side"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: _ctx.getIconName(question),
                              size: "xs",
                              color: _ctx.setIconColor(question)
                            }, null, 8, ["name", "color"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(`Questão ${index + 1}`), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["disable", "class", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["offset"])), [
    [
      _directive_touch_pan,
      _ctx.moveFab,
      void 0,
      {
        prevent: true,
        mouse: true
      }
    ]
  ])
}